



















import { Component, Prop } from 'vue-property-decorator';
import MenuEventsMixin from '@/views/layout/navigation/mixins/menu-events-mixin';
import { mixins } from 'vue-class-component';
import query from '@/components/query/query-constructor';
import PickersBaseMixin from '@/views/reports/pickers/base';
@Component
export default class NavbarBoostViewMenu extends mixins(MenuEventsMixin,PickersBaseMixin)  {
  @Prop({ default: 'var(--color-mobile-menu-bg)' })
  backgroundColor: string;

  @Prop()
  changePlanClick;

  setBoostMode() {
    this.$store.commit('loading', true);
    this.$store.commit('setReportBoost', !this.$store.state.table.reportBoostEnabled)
    this.pushURL()
    this.changePlanClick?.()
  }

  mounted() {
    const routeParams = query.decode(this.$route.params.data);
    if(!routeParams) return;
    const {reportBoostEnabled} = routeParams;

    this.$store.commit('setReportBoost', reportBoostEnabled || JSON.parse(localStorage.getItem('report-boost-enabled'))  || false);
  }
}
